import Api from "../utils/api";

const ModeratorService = {
  admin: {
    get: async (params = {}) =>
      Api.createResponse("app/admin/moderators/", params),
    update: async (params = {}) =>
      Api.createResponse("app/admin/moderators/update", params),
    create: async (params = {}) =>
      Api.createResponse("app/admin/moderators/create", params),
    delete: async (params = {}) =>
      Api.createResponse("app/admin/moderators/delete", params),
  },
};

export default ModeratorService;
